import { reset } from 'redux-form';
import {
    CREATE_REPORT_USER_ERROR,
    CREATE_REPORT_USER_START,
    CREATE_REPORT_USER_SUCCESS
} from '../../constants';

import { closeReportUserModal, openThankYouModal } from '../modalActions';

import { createReportUser } from '../../lib/graphql/common';
import { getReportType } from '../../lib/graphql';

export function manageReportUser(values, props) {
    return async (dispatch, getState, { client }) => {

        await dispatch({ type: CREATE_REPORT_USER_START });

        try {
            const { data } = await client.query({
                query: getReportType,
                variables: {
                    id: Number(values?.reportId),
                }
            });
            const userData = await client.mutate({
                mutation: createReportUser,
                variables: {
                    reportId: data.getReportType?.result?.id,
                    reportType: data?.getReportType?.result?.reportType,
                    reporterName: values?.reporterName,
                    profileId: props?.initialValues?.profileId,
                    reporterId: values?.reporterId,
                }
            });

            if (userData.data.CreateReportUser.status == "success") {
                await dispatch({ type: CREATE_REPORT_USER_SUCCESS });
                dispatch(closeReportUserModal());
                dispatch(reset('ReportUserForm'));
                dispatch(openThankYouModal());
            } else {
                showToaster({ messageId: 'commonError', toasterType: 'error' })
            }
        } catch (error) {
            await dispatch({
                type: CREATE_REPORT_USER_ERROR,
                payload: {
                    error
                }
            });
        }
    }
}